module.exports = __webpack_public_path__ + "img/gdpr_img.e2755c33.svg";